import React from "react";
import { Box, Button, SimpleGrid, Text, VStack, useColorModeValue } from "@chakra-ui/react";

const groups = [
  {
    name: "Basic",
    items: [
      { label: "Text", inputType: "TEXT" },
      { label: "Text Area", inputType: "TEXTAREA", width: 12 },
      { label: "Number", inputType: "NUMBER", width: 4 },
      { label: "Decimal", inputType: "DECIMAL", width: 4 },
      { label: "Date", inputType: "DATE", width: 4 },
      { label: "Date & Time", inputType: "DATETIME", width: 4 },
    ],
  },
  {
    name: "Choices",
    items: [
      { label: "Yes / No", inputType: "YES_NO", width: 4 },
      { label: "Radio", inputType: "RADIO", options: true },
      { label: "Dropdown", inputType: "SELECT", options: true },
      { label: "Multi Select", inputType: "MULTI_SELECT", options: true },
      { label: "Checkbox", inputType: "CHECKBOX", width: 4 },
    ],
  },
  {
    name: "Business",
    items: [
      { label: "Currency", inputType: "CURRENCY", width: 4 },
      { label: "Percentage", inputType: "PERCENTAGE", width: 4 },
      { label: "Value Help", inputType: "VALUE_HELP" },
      { label: "Read Only", inputType: "READ_ONLY" },
      { label: "Calculated", inputType: "CALCULATED", readOnly: true },
    ],
  },
  {
    name: "Review",
    items: [
      { label: "Risk Question", inputType: "QUESTION_YES_NO", width: 12 },
      { label: "File Upload", inputType: "FILE_UPLOAD", width: 12 },
      { label: "Excel Upload", inputType: "EXCEL_UPLOAD", width: 12 },
    ],
  },
  {
    name: "Layout",
    items: [
      { label: "Heading", inputType: "HEADING", width: 12 },
      { label: "Instruction", inputType: "INSTRUCTION", width: 12 },
      { label: "Separator", inputType: "SEPARATOR", width: 12 },
    ],
  },
];

const RiskReviewComponentPalette = ({ onAddField, isDisabled }) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const groupBg = useColorModeValue("gray.50", "gray.700");

  return (
    <Box bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={4}>
      <Text fontWeight="semibold" mb={3}>
        Components
      </Text>
      <VStack align="stretch" spacing={4}>
        {groups.map((group) => (
          <Box key={group.name} bg={groupBg} borderRadius="md" p={3}>
            <Text color="gray.500" fontSize="xs" fontWeight="bold" mb={2}>
              {group.name}
            </Text>
            <SimpleGrid columns={2} spacing={2}>
              {group.items.map((item) => (
                <Button
                  key={item.inputType}
                  size="sm"
                  variant="outline"
                  justifyContent="flex-start"
                  whiteSpace="normal"
                  h="auto"
                  minH="34px"
                  bg={bg}
                  isDisabled={isDisabled}
                  onClick={() => onAddField?.(item)}
                >
                  {item.label}
                </Button>
              ))}
            </SimpleGrid>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default RiskReviewComponentPalette;
